import { createContext, useContext, useEffect } from "react";
import { mediaUrl, useApi } from "@/lib/api";

const SiteContext = createContext({ settings: null, legal: [] });

export const SiteProvider = ({ children }) => {
  const { data: settings } = useApi("/settings/public");
  const { data: legal } = useApi("/legal");
  const { data: menuPages } = useApi("/menu-pages");

  useEffect(() => {
    if (settings?.favicon_url) {
      const el = document.getElementById("site-favicon");
      if (el) el.href = mediaUrl(settings.favicon_url);
    }
  }, [settings]);

  return <SiteContext.Provider value={{ settings: settings || null, legal: legal || [], menuPages: menuPages || [] }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);

const DEFAULT_NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const useMenu = (kind = "nav") => {
  const { settings, menuPages = [] } = useSite();
  const base = settings?.[kind === "nav" ? "nav_menu" : "footer_menu"];
  const links = base?.length ? base : DEFAULT_NAV;
  const extra = menuPages.filter((p) => (kind === "nav" ? p.show_in_navbar : p.show_in_footer)).map((p) => ({ to: `/page/${p.slug}`, label: p.menu_label || p.title }));
  return [...links, ...extra.filter((e) => !links.some((l) => l.to === e.to))];
};
